module.exports = __webpack_public_path__ + "static/media/traffic-alert-planned.31a8c838.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/traffic-alert-planned.svg
// module id = 660
// module chunks = 0